/**
 * Oculta el efecto de esqueleto de un elemento HTML.
 *
 * @param {HTMLElement} block - El elemento al que se eliminará el efecto de esqueleto.
 */
export const hideSkeleton = block => {
  if (!block) return

  block.classList.remove('skeleton')
  block.style.height = ''
  block.style.width = ''
}

export const hideSkeletonContainer = block => {
  if (!block) return
  block.remove()
}

/**
 * Muestra un efecto de esqueleto en un elemento HTML.
 *
 * @param {HTMLElement} block - El elemento al que se aplicará el efecto de esqueleto.
 * @param {string|null} [width=null] - Ancho opcional del esqueleto. Si se proporciona, se aplicará como estilo en línea.
 * @param {string|null} [height=null] - Alto opcional del esqueleto. Si se proporciona, se aplicará como estilo en línea.
 */
export const showSkeleton = (block, width = null, height = null) => {
  if (!block) return

  if (height) {
    block.style.height = height
  }

  if (width) {
    block.style.width = width
  }

  block.classList.add('skeleton')
}
